import { FormatModule } from "tabulator-tables";
import clickIsOutsideElementBounds from "@root/services/clickIsOutsideElementBounds";

const { image: imageFormatter } = FormatModule.formatters;

export default function (cell, formatterParams, onRendered) {
  const { image, thumbnail, alt } = cell.getValue();

  const container = document.createElement('div');
  container.classList.add('w-100', 'h-100', 'd-flex', 'align-items-center', 'justify-content-center');
  const _cell = {
    ...cell,
    getValue() {
      return thumbnail;
    },
    getRow() {
      return cell.getRow()
    },
  };

  const imgThumbnail = imageFormatter.call(this, _cell, formatterParams, onRendered);

  imgThumbnail.classList.add('img-fluid');

  const modal = document.createElement('dialog');
  modal.innerHTML = `<img src="${image}" alt="${alt}" />`
  modal.addEventListener('click', event => clickIsOutsideElementBounds(modal, event) && modal.close())

  imgThumbnail.style.cursor = 'pointer';
  imgThumbnail.addEventListener('error', imgThumbnail.remove);
  imgThumbnail.addEventListener('load', () => cell.getTable().redraw);

  imgThumbnail.addEventListener("click", function (e) {
    e.stopPropagation();
    !modal.open && modal.showModal();
  });

  container.appendChild(imgThumbnail);
  container.appendChild(modal);

  return container;
}
